/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';

import {
  UPDATE_COHORT_ROLES,
  REMOVE_STAFF_ROLES,
  REMOVE_STAFF_COHORT,
  ADD_COHORT_ROLE_SUCCESS,
  REMOVE_COHORT_ROLE_SUCCESS,
} from './actions';
import { COURSE_NAVIGATION_DATA_SET } from '../CourseNavigationInfo/actions';
import { FETCH_COURSE_ROLES_DATA_SUCCESS } from '../CourseAdmin/actions';

export function CohortRoles(state = Immutable.Map(), action = { type: null }) {
  switch (action.type) {
    case COURSE_NAVIGATION_DATA_SET:
    case ADD_COHORT_ROLE_SUCCESS:
    case REMOVE_COHORT_ROLE_SUCCESS:
    case FETCH_COURSE_ROLES_DATA_SUCCESS:
    case UPDATE_COHORT_ROLES: {
      const roles = Immutable.fromJS(action.roles);
      let newState = state;
      for (const role of roles.values()) {
        newState = newState.set(role.get('id'), role);
      }
      return newState;
    }
    case REMOVE_STAFF_ROLES: {
      const { course, user } = action;

      return state.filterNot((role) => {
        return role.get('course') === course && role.get('user') === user;
      });
    }
    case REMOVE_STAFF_COHORT: {
      const { roleId } = action;
      return state.filterNot((role) => {
        return role.get('id') === roleId;
      });
    }
    default:
      return state;
  }
}
